import {connect} from "react-redux";
import Modal from "../../../components/Chat/ChatCase/Modal/Modal";
import {setShowModalNoRerender, setShowModalRerender} from "../../../actions/modal";


const mapStateToProps = (state) => ({
return: {
showModal: state.modal.showModal,
showModalNoRerender: state.modal.showModalNoRerender
}
});

const mapDispatchToProps = (dispatch) => ({
setShowModalRerender: (bool) => {
dispatch(setShowModalRerender(bool));
},
setShowModalNoRerender: (bool) => {
dispatch(setShowModalNoRerender(bool));
},

});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);